<template>
  <div id="statsModal" class="offcanvas-background">
    <div class="offcanvas offcanvas-right-large"
       v-click-outside="close">
    <div class="offcanvas-header d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center">
        <inline-svg :src="require('@/assets/images/icons/Icon_Score.svg')"
                    class="mr-3"
                    width="40" height="40"/>
        <span class="font-weight-light" style="font-size: 2.5rem">
          {{$t('app.label.stats')}}
        </span>
      </div>
      <span class="btn btn-xs btn-icon btn-hover-primary ml-auto"
         @click="close">
         <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                     width="20" height="20"/>
      </span>
    </div>
    <div class="offcanvas-content h-100 pb-8">
      <div class="resources-list h-100" >
        <div id="frameLoader" class="align-items-center justify-content-center h-100 w-100">
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <iframe id="statIframe"
                class="h-100 w-100">
        </iframe>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HelperMixin from '@/mixins/helperMixin';
import { getToken } from '@/common/jwt.service';
import i18n from '@/i18n';

export default {
  name: 'StatsModal',
  mixins: [HelperMixin],
  computed: {
    ...mapGetters(['currentSession', 'organization']),
  },
  data() {
    return {
      statModal: true,
      path: null,
    };
  },
  methods: {
    load(glue) {
      document.getElementById('frameLoader').style.display = 'flex';
      const frame = document.getElementById('statIframe');
      frame.innerHTML = '';
      frame.src = `${process.env.VUE_APP_API_URL}/api/front/v1/renderstats/${this.currentSession.id}/${glue}/?token=${getToken()}&_locale=${i18n.locale}`;
      frame.addEventListener('load', () => {
        document.getElementById('frameLoader').style.display = 'none';
      });
    },
    close() {
      if (document.getElementById('statsModal').classList.contains('offcanvas-on')) {
        const frame = document.getElementById('statIframe');
        frame.src = '';
        frame.classList.remove('active');
        this.$emit('close', { src: 'stats' });
      }
    },
  },
};
</script>

<style scoped>

</style>
